import React from "react";
import { Link } from "expo-router";
import {
  Header as BaseHeader,
  Exit,
  NavbarPopover as NavbarPopoverBase,
} from "@ptsd/uikit";
import { useQueryClient } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import { Separator, Text, useMedia, XStack } from "tamagui";

import { logout } from "~/utils/logout";
import { usePathIncludes, useSession } from "~/hooks";

export const Header = () => {
  const { sm } = useMedia();
  const { user, organization } = useSession();

  return (
    <BaseHeader.Body
      logo={
        <Link href={"/"}>
          <Text fontFamily={"$subtitle"} fontWeight={"$7"} fontSize={"$3"}>
            {organization?.name}
          </Text>
        </Link>
      }
      data-id={"header-body"}
      media={sm ? "md" : "lg"}
      userName={user?.name}
      {...(user !== undefined
        ? {
            renderButton: <NavbarPopover />,
          }
        : {})}
    >
      {!sm && <HeaderLinks />}
    </BaseHeader.Body>
  );
};

const HeaderLinks = () => {
  const { user } = useSession();
  const { match } = usePathIncludes();

  const { t } = useTranslation("header");
  const navLinks = t("links", { returnObjects: true });

  if (user === undefined) return null;

  return (
    <XStack alignItems="center" gap={"$4"} data-id={"navbar-links-container"}>
      {navLinks.map((item) => (
        <Link href={item.href} key={item.href} data-id={"navbar-links"}>
          <BaseHeader.NavItem
            data-id={"navbar-items"}
            active={match(item.identifier)}
          >
            {item.name}
          </BaseHeader.NavItem>
        </Link>
      ))}
    </XStack>
  );
};

const POPOVER_NAV_BAR_ICON = {
  logout: Exit,
};

const NavbarPopover = () => {
  const { t } = useTranslation("header");
  const popoverNavBarItem = t("popover-actions", {
    returnObjects: true,
  });

  const queryClient = useQueryClient();

  return (
    <>
      <NavbarPopoverBase.Body
        placement="bottom-end"
        data-id={"navbar-popover-body"}
      >
        <NavbarPopoverBase.Trigger
          cursor="pointer"
          data-id={"navbar-popover-trigger"}
        >
          <BaseHeader.HamburgerButton />
        </NavbarPopoverBase.Trigger>
        <NavbarPopoverBase.Content
          backgroundColor={"white"}
          gap={"$2"}
          data-id={"navbar-popover-content"}
        >
          {popoverNavBarItem.map((item, index) => {
            const isLast = index === popoverNavBarItem.length - 1;
            const Icon =
              POPOVER_NAV_BAR_ICON[
                item.action as keyof typeof POPOVER_NAV_BAR_ICON
              ];
            return (
              <NavbarPopoverBase.Close
                data-id={"navbar-popover-item-" + item.action}
                cursor="pointer"
                width={"100%"}
                alignItems="flex-start"
                onPress={() => {
                  if (item.action === "logout") {
                    queryClient.clear();
                    void logout();
                  }
                }}
                key={index}
              >
                <NavbarPopoverBase.Item alignItems="center" last={isLast}>
                  <Icon />
                  <NavbarPopoverBase.ItemText
                    variant={item.action === "logout" ? "danger" : "default"}
                  >
                    {item.text}
                  </NavbarPopoverBase.ItemText>
                </NavbarPopoverBase.Item>
                {isLast ? null : (
                  <Separator
                    borderBottomWidth={"$0.2"}
                    width={"100%"}
                    borderColor={"$gray-100"}
                  />
                )}
              </NavbarPopoverBase.Close>
            );
          })}
        </NavbarPopoverBase.Content>
      </NavbarPopoverBase.Body>
    </>
  );
};
